import { Component, inject, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AuthService } from '../../../auth/auth.service';
import { EXTERNALS_QUERIES } from '@job-v2/ats-utils';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-home',
  template: `
    <div>
        <p-progress-spinner class="absolute top-[40%] left-[46%]" ariaLabel="loading" />
    </div>
  `,
  styles: [],
  imports: [ProgressSpinnerModule],
})
export class HomeComponent implements OnInit {
  private readonly authService = inject(AuthService)
  private readonly activatedRoute = inject(ActivatedRoute);
  queries !: Params
  
  constructor (private router: Router) {}
  async ngOnInit(): Promise<void> {
    this.queries = await firstValueFrom(this.activatedRoute.queryParams);

    if (this.queries[EXTERNALS_QUERIES.NAV_T] && Object.keys(this.queries).length === 1)
      return this.authService.getAuthenticatedUser(true)
    else if (Object.keys(this.queries).length === 0){
      return await this.authService.getAuthenticatedUser(true)
    }
    else {
      await this.authService.getAuthenticatedUser(false)
      this.handleRedirection()
    }
  }

  handleRedirection () {
    const positionId = this?.queries?.[EXTERNALS_QUERIES.POSITION_ID];
    const draftId = this.queries?.[EXTERNALS_QUERIES.DRAFT_ID]
    const boardId = this.queries?.[EXTERNALS_QUERIES.BOARD_ID]
    if (positionId) {
      return this.router.navigate([`/management/jobs/create/from/${positionId}`], {
        queryParams: { _nav_t: null, positionId: null },
        queryParamsHandling: 'merge',
      })
    }
    if (draftId) {
      return this.router.navigate([`/management/jobs/create/from/draft/${draftId}`], {
      queryParams: { _nav_t: null , draftId: null},
      queryParamsHandling: 'merge',
    })
    }
    if (boardId) {
      return this.router.navigate([`/management/jobs/board/${boardId}`], {
      queryParams: { _nav_t: null, boardId: null },
      queryParamsHandling: 'merge',
    })
    }
    return this.router.navigate(['/dashboard'], {
      queryParams: null,
      queryParamsHandling: 'merge',
    });
  }
}
